module.exports = {"654321100":"布尔津镇","654321101":"冲乎尔镇","654321102":"窝依莫克镇","654321103":"阔斯特克镇","654321201":"杜来提乡","654321204":"也格孜托别乡","654321205":"禾木哈纳斯蒙古民族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654321.json
// module id = 3144
// module chunks = 0